module.exports = "../study/imgs/maps/Tokyo/S8/Ecosystem/PinusPumila/Tokyo_PinusPumila_MIROC5_RCP45_Now.png";